import { Phone } from 'lucide-react';

export const ContactQuickCTA = () => (
  <section className="py-16 bg-[#f8fafc]" data-testid="quick-contact">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div>
          <h3 className="font-heading text-2xl font-semibold text-[#0f172a] mb-2">
            Need Immediate Assistance?
          </h3>
          <p className="text-[#64748b]">
            Our team is available during business hours for urgent queries.
          </p>
        </div>
        <a
          href="tel:+917791093252"
          data-testid="quick-call-btn"
          className="gradient-btn px-8 py-4 rounded-full font-medium text-white inline-flex items-center gap-2 whitespace-nowrap"
        >
          <Phone size={18} />
          Call Now: +91-77910-93252
        </a>
      </div>
    </div>
  </section>
);
